
import ReceiptAdd from "../../../assets/outline/ReceiptAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceiptAddIcon({ className, dataTestid = "ReceiptAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ReceiptAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
